import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { Message } from 'element-ui'
import { getSettleStatus } from '@/api/settle'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home'),
    meta: {
      title: '点云研智网-专业3D定制服务与点云数字资产交易平台'
    }
  },
  {
    path: '/model',
    name: 'Model',
    component: () => import('@/views/Model'),
    meta: {
      title: '点云研智网-建筑模型 手办打印模型 场景模型 机械工业等模型免费下载'
    }
  },
  {
    path: '/model-detail/:modelId',
    name: 'ModelDetail',
    component: () => import('@/views/ModelDetail'),
    meta: {
      title: '模型详情 | 点云研智网-建筑模型 手办打印模型 场景模型 机械工业等模型免费下载'
    }
  },
  {
    path: '/scene',
    name: 'Scene',
    component: () => import('@/views/Scene'),
    meta: {
      title: '点云研智网-场景点云 自然环境点云 建筑点云 植物等点云免费下载'
    }
  },
  {
    path: '/product/:categoryId?',
    name: 'Product',
    component: () => import('@/views/Product'),
    meta: {
      title: '点云研智网-三维软件开发 三维建模 点云处理 3D打印等定制产品服务'
    }
  },
  {
    path: '/custom-service',
    name: 'CustomService',
    component: () => import('@/views/CustomService/index.vue'),
    meta: {
      title: '定制服务 | 点云研智网-三维软件开发 三维建模 点云处理 3D打印等定制产品服务'
    }
  },
  {
    path: '/custom-service-detail/:id',
    name: 'CustomServiceDetail',
    component: () => import('@/views/CustomService/Detail.vue'),
    meta: {
      title: '定制服务详情 | 点云研智网-三维软件开发 三维建模 点云处理 3D打印等定制产品服务'
    }
  },
  {
    path: '/scene-detail/:workId',
    name: 'SceneDetail',
    component: () => import('@/views/SceneDetail'),
    meta: {
      title: '点云详情 | 点云研智网-场景点云 自然环境点云 建筑点云 植物等点云免费下载'
    }
  },
  {
    path: '/works-detail/:workId',
    name: 'WorksDetail',
    component: () => import('@/views/ProductDetail'),
    meta: {
      title: '作品详情 | 点云研智网-三维软件开发 三维建模 点云处理 3D打印等定制产品服务'
    }
  },
  {
    path: '/seller-join',
    name: 'SellerJoin',
    component: () => import('@/views/UserCenter/SellerJoin'),
    meta: {
      title: '商家招募 | 点云研智网-专业3D定制服务与点云数字资产交易平台',
      hideNavBar: true
    }
  },
  {
    path: '/seller-join-2',
    name: 'SellerJoin2',
    component: () => import('@/views/UserCenter/sellerJoin2'),
    meta: {
      title: '商家入驻 | 点云研智网-专业3D定制服务与点云数字资产交易平台',
      hideNavBar: true
    }
  },
  {
    path: '/real-name-auth',
    name: 'RealNameAuth',
    component: () => import('@/views/RealNameAuth'),
    meta: {
      title: '实名认证 | 点云研智网-专业3D定制服务与点云数字资产交易平台',
      hideNavBar: true
    }
  },
  {
    path: '/personal-auth',
    name: 'PersonalAuth',
    component: () => import('@/views/RealNameAuth/PersonalAuth'),
    meta: {
      title: '个人实名认证 | 点云研智网-专业3D定制服务与点云数字资产交易平台',
      hideNavBar: true
    }
  },
  // {
  //   path: '/enterprise-auth',
  //   name: 'EnterpriseAuth',
  //   component: () => import('@/views/RealNameAuth/EnterpriseAuth'),
  //   meta: {
  //     title: '企业实名认证 | 点云研智网-专业3D定制服务与点云数字资产交易平台',
  //     hideNavBar: true
  //   }
  // },
  {
    path: '/pay',
    name: 'Pay',
    component: () => import('@/views/Pay'),
    meta: {
      title: '订单支付 | 点云研智网-专业3D定制服务与点云数字资产交易平台'
    }
  },
  {
    path: '/model-publish',
    name: 'ModelPublish',
    component: () => import('@/views/ModelPublish'),
    meta: {
      title: '发布模型 | 点云研智网-专业3D定制服务与点云数字资产交易平台',
      hideNavBar: true,
      requireSellerApproved: true,
      requireAuth: true
    }
  },
  {
    path: '/model-publish/step2',
    name: 'ModelPublishStep2',
    component: () => import('@/views/ModelPublish/step2'),
    meta: {
      title: '发布模型 | 点云研智网-专业3D定制服务与点云数字资产交易平台',
      hideNavBar: true,
      requireSellerApproved: true,
      requireAuth: true
    }
  },
  {
    path: '/scene-publish',
    name: 'ScenePublish',
    component: () => import('@/views/ScenePublish'),
    meta: {
      title: '发布点云 | 点云研智网-专业3D定制服务与点云数字资产交易平台',
      hideNavBar: true,
      requireSellerApproved: true,
      requireAuth: true
    }
  },
  {
    path: '/scene-publish/step2',
    name: 'ScenePublishStep2',
    component: () => import('@/views/ScenePublish/step2'),
    meta: {
      title: '发布点云 | 点云研智网-专业3D定制服务与点云数字资产交易平台',
      hideNavBar: true,
      requireSellerApproved: true,
      requireAuth: true
    }
  },
  {
    path: '/product-publish',
    name: 'ProductPublish',
    component: () => import('@/views/ProductPublish'),
    meta: {
      title: '发布作品 | 点云研智网-专业3D定制服务与点云数字资产交易平台',
      hideNavBar: true,
      requireSellerApproved: true,
      requireAuth: true
    }
  },
  {
    path: '/product-publish/step2',
    name: 'ProductPublishStep2',
    component: () => import('@/views/ProductPublish/step2'),
    meta: {
      title: '发布作品 | 点云研智网-专业3D定制服务与点云数字资产交易平台',
      hideNavBar: true,
      requireSellerApproved: true,
      requireAuth: true
    }
  },
  { path: '/product-detail/:id', name: 'ProductDetail', component: () => import('@/views/ProductDetail'), meta: { title: '作品详情 | 点云研智网-三维软件开发 三维建模 点云处理 3D打印等定制产品服务' } },
  { path: '/author-detail/:id', name: 'AuthorDetail', component: () => import('@/views/UserCenter/AuthorDetail'), meta: { title: '作者详情 | 点云研智网-专业3D定制服务与点云数字资产交易平台' } },
  {
    path: '/topic/detail/:id',
    name: 'TopicDetail',
    component: () => import('@/views/Topic/Detail'),
    meta: {
      title: '专题详情 | 点云研智网-专业3D定制服务与点云数字资产交易平台'
    }
  },
  {
    path: '/topic/list',
    name: 'TopicList',
    component: () => import('@/views/Topic/list'),
    meta: {
      title: '专题列表 | 点云研智网-专业3D定制服务与点云数字资产交易平台'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login'),
    meta: {
      title: '登录 | 点云研智网-专业3D定制服务与点云数字资产交易平台',
      hideNavBar: true // 隐藏顶部导航栏
    }
  },
  {
    path: '/bind-pay-wechat',
    name: 'BindPayAlipay',
    component: () => import('@/views/BindPayWeChat'),
    meta: {
      title: '绑定支付宝 | 点云研智网-专业3D定制服务与点云数字资产交易平台',
      hideNavBar: true,
      requireAuth: true
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register'),
    meta: {
      title: '注册 | 点云研智网-专业3D定制服务与点云数字资产交易平台',
      hideNavBar: true // 隐藏顶部导航栏
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About'),
    meta: {
      title: '关于点云研智网 | 点云研智网-专业3D定制服务与点云数字资产交易平台'
    }
  },
  {
    path: '/site/help-service',
    name: 'Agreement',
    component: () => import('@/views/Agreement'),
    meta: {
      title: '协议 | 点云研智网-专业3D定制服务与点云数字资产交易平台'
    }
  },
  {
    path: '/more/detail',
    name: 'MoreDetail',
    component: () => import('@/views/MoreDetail'),
    meta: {
      title: '详情 | 点云研智网-专业3D定制服务与点云数字资产交易平台'
    }
  },
  {
    path: '/bind-wx-quick-login',
    name: 'BindWxQuickLogin',
    component: () => import('@/views/BindWxQuickLogin'),
    meta: {
      title: '微信登录处理 | 点云研智网-专业3D定制服务与点云数字资产交易平台',
      hideNavBar: true
    }
  },
  {
    path: '/after-sales',
    name: 'AfterSales',
    component: () => import('@/views/AfterSales/index.vue'),
    meta: {
      title: '申请售后 | 点云研智网-专业3D定制服务与点云数字资产交易平台',
      requireAuth: true
    }
  },
  // 个人中心路由
  {
    path: '/user-center',
    name: 'UserCenter',
    component: () => import('@/views/UserCenter'),
    meta: { title: '个人中心 | 点云研智网-专业3D定制服务与点云数字资产交易平台', requireAuth: true },
    redirect: '/user-center/buyer',
    children: [
      // 买家中心路由
      {
        path: 'buyer',
        name: 'BuyerHome',
        component: () => import('@/views/UserCenter/BuyerHome'),
        meta: { title: '买家中心 | 点云研智网-专业3D定制服务与点云数字资产交易平台' }
      },
      {
        path: 'buyer/orders',
        name: 'BuyerOrders',
        component: () => import('@/views/UserCenter/BuyerOrders'),
        meta: { title: '我的订单 | 点云研智网-专业3D定制服务与点云数字资产交易平台' }
      },
      {
        path: 'buyer/recharge',
        name: 'BuyerRecharge',
        component: () => import('@/views/UserCenter/BuyerHome'),
        meta: { title: '充值 | 点云研智网-专业3D定制服务与点云数字资产交易平台' }
      },
      {
        path: 'buyer/funds',
        name: 'BuyerFunds',
        component: () => import('@/views/UserCenter/BuyerHome'),
        meta: { title: '资金明细 | 点云研智网-专业3D定制服务与点云数字资产交易平台' }
      },
      {
        path: 'buyer/invoice',
        name: 'BuyerInvoice',
        component: () => import('@/views/UserCenter/BuyerInvoice'),
        meta: { title: '发票管理 | 点云研智网-专业3D定制服务与点云数字资产交易平台' }
      },
      {
        path: 'buyer/footprints',
        name: 'BuyerFootprints',
        component: () => import('@/views/UserCenter/BuyerFootprints'),
        meta: { title: '我的足迹 | 点云研智网-专业3D定制服务与点云数字资产交易平台' }
      },
      {
        path: 'buyer/favorites',
        name: 'BuyerFavorites',
        component: () => import('@/views/UserCenter/BuyerFavorites'),
        meta: { title: '我的收藏 | 点云研智网-专业3D定制服务与点云数字资产交易平台' }
      },
      {
        path: 'buyer/custom-orders',
        name: 'BuyerCustomOrders',
        component: () => import('@/views/UserCenter/BuyerCustomOrders'),
        meta: { title: '定制订单 | 点云研智网-专业3D定制服务与点云数字资产交易平台' }
      },
      {
        path: 'buyer/settings',
        name: 'BuyerSettings',
        component: () => import('@/views/UserCenter/BuyerSettings'),
        meta: { title: '账号设置 | 点云研智网-专业3D定制服务与点云数字资产交易平台' }
      },
      {
        path: 'buyer/security',
        name: 'BuyerSecurity',
        component: () => import('@/views/UserCenter/BuyerHome'),
        meta: { title: '安全中心 | 点云研智网-专业3D定制服务与点云数字资产交易平台' }
      },
      // 卖家中心路由
      {
        path: 'seller',
        name: 'SellerHome',
        component: () => import('@/views/UserCenter/SellerHome'),
        meta: { title: '卖家中心 | 点云研智网-专业3D定制服务与点云数字资产交易平台' }
      },
      // {
      //   path: 'seller/promotion',
      //   name: 'SellerPromotion',
      //   component: () => import('@/views/UserCenter/SellerHome'),
      //   meta: { title: '限时特惠 | 点云研智网-专业3D定制服务与点云数字资产交易平台', requireSeller: true }
      // },
      {
        path: 'seller/models',
        name: 'SellerModels',
        component: () => import('@/views/UserCenter/SellerModels'),
        meta: { title: '模型管理 | 点云研智网-专业3D定制服务与点云数字资产交易平台', requireSeller: true }
      },
      {
        path: 'seller/scenes',
        name: 'SellerScenes',
        component: () => import('@/views/UserCenter/SellerScenes'),
        meta: { title: '点云管理 | 点云研智网-专业3D定制服务与点云数字资产交易平台', requireSeller: true }
      },
      {
        path: 'seller/products',
        name: 'SellerProducts',
        component: () => import('@/views/UserCenter/SellerProducts'),
        meta: { title: '作品管理 | 点云研智网-专业3D定制服务与点云数字资产交易平台', requireSeller: true }
      },
      // {
      //   path: 'seller/works',
      //   name: 'SellerWorks',
      //   component: () => import('@/views/UserCenter/SellerHome'),
      //   meta: { title: '作品管理 | 点云研智网-专业3D定制服务与点云数字资产交易平台', requireSeller: true }
      // },
      // {
      //   path: 'seller/albums',
      //   name: 'SellerAlbums',
      //   component: () => import('@/views/UserCenter/SellerHome'),
      //   meta: { title: '专辑管理 | 点云研智网-专业3D定制服务与点云数字资产交易平台', requireSeller: true }
      // },
      // {
      //   path: 'seller/copyright',
      //   name: 'SellerCopyright',
      //   component: () => import('@/views/UserCenter/SellerHome'),
      //   meta: { title: '版权保护 | 点云研智网-专业3D定制服务与点云数字资产交易平台', requireSeller: true }
      // },
      // {
      //   path: 'seller/violations',
      //   name: 'SellerViolations',
      //   component: () => import('@/views/UserCenter/SellerHome'),
      //   meta: { title: '违规记录 | 点云研智网-专业3D定制服务与点云数字资产交易平台', requireSeller: true }
      // },
      {
        path: 'seller/transactions',
        name: 'SellerTransactions',
        component: () => import('@/views/UserCenter/SellerTransactions'),
        meta: { title: '交易汇总 | 点云研智网-专业3D定制服务与点云数字资产交易平台', requireSeller: true }
      },
      // {
      //   path: 'seller/funds',
      //   name: 'SellerFunds',
      //   component: () => import('@/views/UserCenter/SellerHome'),
      //   meta: { title: '资金明细 | 点云研智网-专业3D定制服务与点云数字资产交易平台', requireSeller: true }
      // },
      // {
      //   path: 'seller/authorization',
      //   name: 'SellerAuthorization',
      //   component: () => import('@/views/UserCenter/SellerHome'),
      //   meta: { title: '授权记录 | 点云研智网-专业3D定制服务与点云数字资产交易平台', requireSeller: true }
      // },
      // {
      //   path: 'seller/reviews',
      //   name: 'SellerReviews',
      //   component: () => import('@/views/UserCenter/SellerHome'),
      //   meta: { title: '评价管理 | 点云研智网-专业3D定制服务与点云数字资产交易平台', requireSeller: true }
      // },
      // {
      //   path: 'seller/data-overview',
      //   name: 'SellerDataOverview',
      //   component: () => import('@/views/UserCenter/SellerHome'),
      //   meta: { title: '数据概况 | 点云研智网-专业3D定制服务与点云数字资产交易平台', requireSeller: true }
      // },
      // {
      //   path: 'seller/search-ranking',
      //   name: 'SellerSearchRanking',
      //   component: () => import('@/views/UserCenter/SellerHome'),
      //   meta: { title: '搜索排行 | 点云研智网-专业3D定制服务与点云数字资产交易平台', requireSeller: true }
      // },
      {
        path: 'seller/withdraw',
        name: 'SellerWithdraw',
        component: () => import('@/views/UserCenter/SellerWithdraw'),
        meta: { title: '提现 | 点云研智网-专业3D定制服务与点云数字资产交易平台', requireSeller: true }
      },
      {
        path: 'seller/grab-orders',
        name: 'SellerGrabOrders',
        component: () => import('@/views/UserCenter/SellerGrabOrders'),
        meta: { title: '抢定制单 | 点云研智网-专业3D定制服务与点云数字资产交易平台', requireSeller: true }
      },
      {
        path: 'seller/my-custom',
        name: 'SellerMyCustom',
        component: () => import('@/views/UserCenter/SellerMyCustom'),
        meta: { title: '我的定制 | 点云研智网-专业3D定制服务与点云数字资产交易平台', requireSeller: true }
      },
      // {
      //   path: 'seller/info',
      //   name: 'SellerInfo',
      //   component: () => import('@/views/UserCenter/SellerHome'),
      //   meta: { title: '商户信息 | 点云研智网-专业3D定制服务与点云数字资产交易平台', requireSeller: true }
      // }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// 全局路由守卫 - 设置页面标题和权限校验
import { hasToken } from '@/utils/auth'

router.beforeEach(async (to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }

  // 检查是否需要登录
  if (to.matched.some(record => record.meta.requireAuth)) {
    if (!hasToken()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
      return
    }
  }

  // 检查是否需要卖家权限
  if (to.meta.requireSeller || to.meta.requireSellerApproved) {
    let userInfo = store.state.user.userInfo

    // 如果有 token 但没有用户信息，先获取用户信息
    const tokenExists = hasToken()
    if (!userInfo && tokenExists) {
      try {
        userInfo = await store.dispatch('user/getUserInfo')
      } catch (error) {
        console.error('获取用户信息失败:', error)
      }
    }

    // 没有登录
    if (!tokenExists) {
        next({
            path: '/login',
            query: { redirect: to.fullPath }
        })
        return
    }

    // roleType 不为 1 表示普通用户，需要跳转到入驻页面
    if (!userInfo || userInfo.roleType !== '1') {
      next({ path: '/seller-join' })
      return
    }

    if (to.meta.requireSellerApproved) {
      let settleStatus = store.state.user.settleStatus
      if (settleStatus === null || settleStatus === undefined) {
        try {
          const res = await getSettleStatus()
          settleStatus = res && res.data ? res.data.status : null
          store.commit('user/SET_SETTLE_STATUS', settleStatus)
        } catch (error) {
          console.error('获取入驻状态失败:', error)
        }
      }

      if (settleStatus !== '1') {
        Message({
          message: '入驻审核未通过，暂不能发布',
          type: 'warning',
          duration: 3000
        })
        next({ path: '/seller-join' })
        return
      }
    }
  }

  next()
})

export default router
